export default __webpack_public_path__ + "static/media/heating.1f2e0516.png";